// extracted by css-extract-rspack-plugin
export default {"dottedWrapper":"dotted-wrapper--xVk7Cm8wgsAU4cbP","text":"text--xmNTy6IsSzcA0FG8","dot":"dot--eBJO4PGf7NUaFxzm","countingMore":"counting-more--AeDbrzvM3j4XqN9e"};